import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { calculateTotals } from "../lib/financials.lib";
import type { FinancialSummary, Order } from "../types";
import { draftLineItemsAtomFamily } from "./draft-return.atom";

const EMPTY_SUMMARY: FinancialSummary = {
  refundTotal: 0,
  exchangeTotal: 0,
  discountTotal: 0,
  amountDue: 0,
  currency: "EUR",
};

export const financialSummaryAtomFamily = atomFamily(
  (params: { orderId: string; order: Order | null }) =>
    atom<FinancialSummary>((get) => {
      const lineItems = get(draftLineItemsAtomFamily(params.orderId));
      if (!params.order || lineItems.length === 0) return EMPTY_SUMMARY;
      return calculateTotals(lineItems, params.order);
    }),
  (a, b) => a.orderId === b.orderId && a.order === b.order,
);
